/** Localized translation namespace entries for the animal-browser module. */
export const animalBrowserTranslations = {
    CS: {
        animalBrowser: {
            breedersOverviewInStable: 'Přehled plemenic ve stáji',
            exportCows: 'Export plemenic ve stáji',
            comprehensiveBreedingFemaleBrowser: 'Komplexní seznam plemenic',
            comprehensiveCalfBrowser: 'Komplexní seznam telat',
            breedersBrowser: 'Prohlížeč plemenic',
            farmsStables: 'Hospodářství/stáje',
            exportFarmsStables: 'Export hospodářství/stájí',
            showCowsOverview: 'Zobrazit přehled krav',
            showCalvesOverview: 'Zobrazit přehled telat',
            exportDisabled: 'Žádná data pro export',
            printIk: 'Tisk IK',
            printIkKb: 'Tisk IK/KB',
            printB: 'Tisk B',
            printBTooltip: 'Tisk karet býka',
            printJ: 'Tisk J',
            printJTooltip: 'Tisk inseminačních karet',
            documentTypeFor: 'Druh dokladu pro {{animal}}',
            heifers: 'jalovice ( J ) ‐ zvolte typ',
            bulls: 'býčky ( B )',
            breedingFemales: 'plemenice ‐ zvolte typ',
            bulkPrint: 'Hromadný tisk',
            exportInProgress: 'Probíhá export',
            calvesInFarm: 'Přehled telat v hospodářství',
            backToList: 'Zpět na seznam',
            femaleCalf: 'J',
            maleCalf: 'B',
            exportCalvesInFarm: 'Export telat v hospodářství',
            loadCabFemalesList: 'Načtení komplexního seznamu plemenic.',
            zeroCabFemalesMatchTheFilter: 'Filtru neodpovídají žádné plemenice.',
            cabFemalesFiltering: 'Filtrování plemenic.',
            loadCabCalvesList: 'Načítání komplexního seznamu telat.',
            zeroCabCalvesMatchTheFilter: 'Žádná telata neodpovídají filtru.',
            cabCalvesFiltering: 'Filtrování telat.',
            loadAnimalsList: 'Načtení skupiny zvířat',
            renameAnimalList: 'Přejmenování skupiny zvířat',
            animalListRenamed: 'Skupina zvířat úspěšně přejmenována',
            deleteAnimalList: 'Odstranění skupiny zvířat',
            animalListDeleted: 'Skupina zvířat byl úspěšně smazána',
            createAnimalList: 'Vytvoření skupiny zvířat',
            animalListCreated: 'Skupina zvířat úspěšně vytvořena',
            saveAnimalList: 'Uložení skupiny zvířat',
            breederListSuccess: 'Skupina plemenic úspěšně uložena',
            calvesListSuccess: 'Skupina telat úspěšně uložena',
            addAnimals: 'Přidat zvířata',
            animalsAdded: 'Zvířata byla úspěšně přidána.',
            addAnimalsFromFile: 'Přidat zvířata ze souboru',
            addAnimalsFromDb: 'Vybrání skupiny zvířat',
            animalsAddedFromDb: 'Skupina zvířat byla úspěšně vybrána.',
            deletingAnimals: 'Odstranění zvířat',
            animalsDeleted: 'Zvířata byla úspěšně smazána',
            motherLink: 'Načtení odkazu na matku',
            filter: 'Filtrovat',
            search: 'Vyhledat',
            reset: 'Obnovit',
            filterSettings: 'Nastavení filtru',
            selectList: 'Vybrat skupinu',
            selectAnimalList: 'Vyberte skupinu zvířat',
            saveList: 'Uložit skupinu',
            manageLists: 'Spravovat skupiny',
            deleteAnimals: 'Smazat zvířata',
            animalList: 'Skupina zvířat',
            noSavedLists: 'Nebyly uloženy žádné slupiny.',
            managementOfSavedLists: 'Správa uložených skupin',
            listAlreadyExists: 'Skupina se zvoleným názvem již existuje. Přejete si přepsat uloženou skupinu?',
            atLeastOneAnimal: 'Skupina zvířat musí obsahovat minimálně jedno zvíře.',
            areYouSure: 'Jste si jisti, že chcete opravdu smazat tuto skupinu?',
            breeder: 'Chovatel',
            district: 'Okres',
            farm: 'Hospodářství',
            organizationIns: 'Oprávněná organizace ‐ Inseminace',
            organizationPt: 'Oprávněná organizace ‐ KU',
            organizationCenterIns: 'Středisko ‐ Inseminace',
            organizationCenterPt: 'Středisko ‐ KU',
            stable: 'Stáj',
            organizationPtTooltip: 'Zadejte kód nebo obchodní jméno oprávněné organizace.',
            organizationInsTooltip: 'Zadejte kód nebo obchodní jméno oprávněné organizace.',
            organizationCenterPtTooltip: 'Zadejte kód střediska oprávněné organizace.',
            organizationCenterInsTooltip: 'Zadejte kód střediska oprávněné organizace.',
            districtTooltip: 'Zadejte třímístný kód, kód RÚIAN nebo název okresu.',
            breederTooltip: 'Zadejte registrační číslo nebo obchodní jméno chovatele.',
            farmTooltip: 'Zadejte kód nebo název hospodářství / registrační číslo nebo obchodní jméno chovatele.',
            stableTooltip: 'Zadejte kód nebo název stáje / registrační číslo nebo obchodní jméno chovatele.',
        },
    },
    EN: {
        animalBrowser: {
            breedersOverviewInStable: 'Breeder cows in stable',
            exportCows: 'Export cows in stable',
            comprehensiveBreedingFemaleBrowser: 'Comprehensive breeding female browser',
            comprehensiveCalfBrowser: 'Comprehensive calf browser',
            breedersBrowser: 'Breeder cows browser',
            farmsStables: 'Stables',
            exportFarmsStables: 'Stables export',
            showCowsOverview: 'Show cows overview',
            showCalvesOverview: 'Show calves overview',
            exportDisabled: 'No data to export',
            printIk: 'Print IK',
            printIkKb: 'Print IK/KB',
            printB: 'Print B',
            printBTooltip: 'Print bull cards',
            printJ: 'Print J',
            printJTooltip: 'Print insemination cards',
            documentTypeFor: 'Document type for {{animal}}',
            heifers: 'heifers (J) - select type',
            bulls: 'bulls (B)',
            breedingFemales: 'breeding females - select type',
            bulkPrint: 'Bulk print',
            exportInProgress: 'Export in progress',
            calvesInFarm: 'Calves in farm',
            backToList: 'Back to list',
            femaleCalf: 'F',
            maleCalf: 'M',
            exportCalvesInFarm: 'Export calves in farm',
            loadCabFemalesList: 'Loading complex list of breeding cows.',
            zeroCabFemalesMatchTheFilter: 'Zero breeding cows match the filter.',
            cabFemalesFiltering: 'Filter breeding cows.',
            loadCabCalvesList: 'Loading complex list of calves.',
            zeroCabCalvesMatchTheFilter: 'Zero calves match the filter.',
            cabCalvesFiltering: 'Filtering calves.',
            loadAnimalsList: 'Load animals groups',
            renameAnimalList: 'Rename animal group',
            animalListRenamed: 'Animal group renamed successfully',
            deleteAnimalList: 'Delete animal group',
            animalListDeleted: 'Animal group was successfully deleted',
            createAnimalList: 'Create animal group',
            animalListCreated: 'Animals group was created successfully',
            saveAnimalList: 'Save animal group',
            breederListSuccess: 'List of breeding cows saved successfully',
            calvesListSuccess: 'Group of calves saved successfully',
            addAnimals: 'Add animals',
            animalsAdded: 'Animals were successfully added.',
            addAnimalsFromFile: 'Add animals from file',
            addAnimalsFromDb: 'Select animal group',
            animalsAddedFromDb: 'Animal group was successfully selected.',
            deletingAnimals: 'Deleting animals',
            animalsDeleted: 'Animals were successfully deleted',
            motherLink: 'Load of mother link',
            filter: 'Filter',
            search: 'Search',
            reset: 'Reset',
            filterSettings: 'Filter settings',
            selectList: 'Select group',
            selectAnimalList: 'Select animal group',
            saveList: 'Save group',
            manageLists: 'Manage groups',
            deleteAnimals: 'Delete animals',
            animalList: 'Animal group',
            noSavedLists: 'No groups were saved.',
            managementOfSavedLists: 'Management of saved groups',
            listAlreadyExists: 'A group with the name you entered already exists. Do you wish to overwrite the saved group?',
            areYouSure: 'Are you sure you want to delete this group?',
            atLeastOneAnimal: 'Animal group has to contain at least one animal.',
            breeder: 'Breeder',
            district: 'District',
            farm: 'Farm',
            organizationIns: 'Authorized organization ‐ Insemination',
            organizationPt: 'Authorized organization ‐ PT',
            organizationCenterIns: 'Organization center ‐ Insemination',
            organizationCenterPt: 'Organization center ‐ PT',
            stable: 'Stable',
            organizationPtTooltip: 'Enter the code or business name of the authorized organization.',
            organizationInsTooltip: 'Enter the unit code of the authorized organization.',
            organizationCenterPtTooltip: 'Enter the code or business name of the authorized organization.',
            organizationCenterInsTooltip: 'Enter the unit code of the authorized organization.',
            districtTooltip: 'Enter the three-digit code, the RÚIAN code or the district name.',
            breederTooltip: 'Enter the breeder\'s registration number or business name.',
            farmTooltip: 'Enter the code or name of the farm / registration number or business name of the breeder.',
            stableTooltip: 'Enter the code or name of the stable / registration number or business name of the breeder.',
        },
    },
};
